const heartbeatFormat: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hourCycle: "h23",
  timeZoneName: "short",
};

export function formatHeartbeatLocal(lastHeartbeatAt: string | null, timeZone?: string): string {
  if (lastHeartbeatAt === null) return "No heartbeat";
  const instant = new Date(lastHeartbeatAt);
  if (Number.isNaN(instant.getTime())) return "No heartbeat";
  const parts = new Intl.DateTimeFormat("en-GB", { ...heartbeatFormat, timeZone }).formatToParts(instant);
  const pick = (type: Intl.DateTimeFormatPartTypes) => parts.find((part) => part.type === type)?.value ?? "";
  return `${pick("year")}-${pick("month")}-${pick("day")} ${pick("hour")}:${pick("minute")}:${pick("second")} ${pick("timeZoneName")}`.trim();
}
